import React, { useEffect } from 'react';
import styled from 'styled-components';
// components
import Title from '../../../components/Title';
import Button from '../../../components/Button';

// assets
import BankLogo from '../../../assets/img/BankLogo.png';
import { useStore } from '../../../context/appContext';
import useGAEventsTracker from '../../../utils/useGAEventsTrackers';

const ImgDiv = styled.div`
  grid-area: content;
  display: inline-grid;
  justify-items: center;
  align-items: center;
`;

const Img = styled.img`
  width: 100%;
`;

function Welcome() {
  const { stepForward, contracts } = useStore();

  const GAEventsTracker = useGAEventsTracker("Welcome Page");
  useEffect(() => {
    GAEventsTracker("Visualiza pantalla bienvenida");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnClick = () => {
    GAEventsTracker("Avanzar");
      stepForward();
  };

  const {
    user: { name },
  } = useStore();


  return (
    <>
      <Title grid="title">¡Bienvenido/a {name}!</Title>
      <ImgDiv>
        <Img src={BankLogo} />
      </ImgDiv>
      <Button filled grid="buttons" onClick={handleOnClick} disabled={!contracts.dataUrl}>
        Avanzar
      </Button>
    </>
  );
}

export default Welcome;
